export default {
    apiUrl: 'DOCKER_API_URL',
    appVersion: '41',
    captchaSiteKey: 'CAPTCHA_SITE_KEY',
    captchaEnabled: 'CAPTCHA_ENABLED',
    tinyMceKey: 'TINY_MCE_KEY',
    googleMapApiKey: 'GOOGLE_MAP_API_KEY',
    userpilotToken: 'USERPILOT_TOKEN',
    uat_slave: 'IS_UAT_SLAVE',
    uat: 'IS_UAT_SERVER',
    googleMapId: 'GOOGLE_MAP_ID'
}